export const testimonials = [
  {
    text: "Since using Sanity Reps, my anxiety levels have decreased significantly. The AI Wellness Rep's responses are incredibly thoughtful and personalized.",
    author: "Sarah M."
  },
  {
    text: "I was skeptical at first, but the 24/7 availability and non-judgmental support has been life-changing. It's like having a compassionate friend always ready to listen.",
    author: "James K."
  },
  {
    text: "The stress management techniques I've learned here have helped me both personally and professionally. Best investment in my mental health ever!",
    author: "Michelle R."
  },
  {
    text: "Having someone to talk to whenever I need has helped me through some really tough times. The AI Wellness Rep remembers our previous conversations and builds on them.",
    author: "David L."
  },
  {
    text: "As someone with a busy schedule, this app has made wellness coaching accessible and convenient. The insights and coping strategies are incredibly valuable.",
    author: "Emma P."
  },
  {
    text: "The relationship advice based on Gottman principles has truly transformed how I communicate with my partner. Thank you, Sanity Reps!",
    author: "Michael S."
  },
  {
    text: "I appreciate how the AI adapts to my needs and provides practical solutions. It's like having a pocket therapist available 24/7.",
    author: "Lisa T."
  }
];
